/**
 * Web variant of {@link configureGoogleSignIn}.
 *
 * The native One Tap SDK (`react-native-nitro-google-signin`) is a Nitro
 * TurboModule with no web build — importing it on web throws at module load.
 * Web Google sign-in goes through Firebase's OAuth popup instead (see
 * `use-google-login.web.ts`), so there is nothing to configure here.
 */
export const configureGoogleSignIn = (): void => {};

/** Web variant of {@link googleSignOut}. Web Google sign-in has no native One Tap cache to clear. */
export const googleSignOut = (): void => {};
